
  import missions from '~/mixins/pages/mission-control/missions'
  export default {
    name: 'Theme2MissionMobileRoadmapLayoutsTypeThree',
    mixins: [missions],
    props: {
      mission: {
        type: Object,
        default: () => ({})
      },
      missionId: {
        type: String,
        default: ''
      },
      extraCoin: {
        type: Number,
        default: 0
      },
      extraCoinStatus: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {}
    },
    computed: {
      missionActivityObj() {
        return this.mission
      },
      loopTimes() {
        return this.activitiesCardLayouts.length + 1
      },
      roundedTimes() {
        if (this.loopTimes <= 2) return 0
        return Math.floor((this.loopTimes - 1) / 2)
      },
      isOddLoop() {
        return this.loopTimes % 2 === 1
      },
      missionType() {
        if (this.mission.mission_type === 1) return 'weekly'
        if (this.mission.mission_type === 2) return 'monthly'
        if (this.mission.mission_type === 3) return 'event'
        if (this.mission.mission_type === 4) return 'guideline'
        return ''
      },
      activitiesDates() {
        const startDate = this.$dayjs(this.missionActivityObj.start_date)
        const endDate = this.$dayjs(this.missionActivityObj.end_date)
        const dates = []
        let currentDate = startDate
        while (currentDate.isSameOrBefore(endDate, 'day')) {
          dates.push(currentDate.format('YYYY-MM-DD')) // or any other format you prefer
          currentDate = currentDate.add(1, 'day')
        }
        return dates
      },
      activities() {
        const startDate = this.$dayjs(this.missionActivityObj.start_date)
        const endDate = this.$dayjs(this.missionActivityObj.end_date)
        const dates = []
        let currentDate = startDate

        while (currentDate.isSameOrBefore(endDate, 'day')) {
          dates.push(currentDate.format('YYYY-MM-DD')) // or any other format you prefer
          currentDate = currentDate.add(1, 'day')
        }

        const dataObjByDate = {}
        dates.forEach(date => {
          const data = this.missionActivityObj?.mission_dates?.find(item => item.date === date)
          if (data) {
            dataObjByDate[date] = data?.activities
          }
        })

        return dataObjByDate
      },
      activitiesCardLayouts() {
        const layouts = []
        const activitiesDates = Object.keys(this.activities)

        for (let actDate = 0; actDate < activitiesDates.length; actDate++) {
          const mainArr = this.activities[activitiesDates[actDate]]
          for (let i = 0; i < mainArr.length; i += 2) {
            const pair = mainArr.slice(i, i + 2) // get 2 elements
            layouts.push({
              activities: pair,
              date: i === 0 ? activitiesDates[actDate] : null
            })
          }
        }

        return layouts
      },
      dateInGroup() {
        const firstDayDate = this.activitiesDates[0]
        let activitiesCardLayoutsWithoutFirstTwoDates = []
        if (this.activities[firstDayDate]?.length > 2) {
          activitiesCardLayoutsWithoutFirstTwoDates = this.activitiesCardLayouts.slice(2)
        } else {
          activitiesCardLayoutsWithoutFirstTwoDates = this.activitiesCardLayouts.slice(1)
        }

        let latestDate = null

        const cloneActivitiesCardLayouts = activitiesCardLayoutsWithoutFirstTwoDates.map(
          (el, index) => {
            if (index === 0) {
              latestDate = firstDayDate
            } else if (el.date) {
              latestDate = el.date
            }
            return {
              ...el,
              date: latestDate
            }
          }
        )
        return cloneActivitiesCardLayouts
      }
    },
    methods: {
      getValueByRoundedTimes(roundedTimes) {
        const startValue = 480
        const increment = 380

        if (roundedTimes < 1) return null

        return startValue + (roundedTimes - 1) * increment
      },
      getStartLineStyle() {
        if (this.checkIfTodayDateIsAfter(this.activitiesDates[0])) {
          return {
            borderColor: '#ddaf3e'
          }
        }
        return {}
      },
      getFirstRectangleStyle() {
        const theFirstDateOfTheActivity = this.activitiesDates[0]
        if (!this.checkIfTodayDateIsAfter(theFirstDateOfTheActivity)) {
          return {}
        }
        if (this.activities[theFirstDateOfTheActivity]?.length > 2) {
          return {
            borderColor: '#ddaf3e'
          }
        } else {
          if (this.checkIfTodayDateIsAfter(this.activitiesDates[1])) {
            return {
              borderColor: '#ddaf3e'
            }
          }
          if (this.checkIfTodayDateIsAfter(theFirstDateOfTheActivity)) {
            return {
              borderTopColor: '#ddaf3e'
            }
          }
          return {}
        }
      },
      getFirstRightRoundedStyle() {
        const activityDate = this.activitiesDates[0]
        if (this.activities[activityDate]?.length > 2) {
          if (this.checkIfTodayDateIsAfter(activityDate)) {
            return {
              borderColor: '#ddaf3e'
            }
          }
        } else {
          const theSecondDate = this.activitiesDates[1]
          if (this.checkIfTodayDateIsAfter(theSecondDate)) {
            return {
              borderColor: '#ddaf3e'
            }
          }
        }
        return {}
      },
      getRectangleStyle(index) {
        let extraCount = 0
        if (this.activities[this.activitiesDates[0]].length <= 2) {
          extraCount = 1
        }

        const spliceYourRange = this.dateInGroup.slice(
          index * 2 + extraCount,
          index * 2 + 2 + extraCount
        )

        // For the last rectangle box in the loop
        if (this.isOddLoop) {
          // Check if the roundedTimeIndex is the lasted of the loop
          // Check if the last date is passed
          if (index + 1 === this.roundedTimes) {
            if (
              this.checkIfTodayDateIsAfter(this.activitiesDates[this.activitiesDates.length - 1])
            ) {
              return {
                borderColor: '#ddaf30'
              }
            }
          }
        }

        if (spliceYourRange?.length === 2) {
          if (
            spliceYourRange[0].date === spliceYourRange[1].date &&
            this.checkIfTodayDateIsAfter(spliceYourRange[0].date)
          ) {
            return {
              borderColor: '#ddaf3e'
            }
          } else {
            return {
              borderTopColor: this.checkIfTodayDateIsAfter(spliceYourRange[0].date)
                ? '#ddaf3e'
                : 'auto',
              borderBottomColor: this.checkIfTodayDateIsAfter(spliceYourRange[1].date)
                ? '#ddaf3e'
                : 'auto'
            }
          }
        } else if (spliceYourRange?.length === 1) {
          const date = spliceYourRange[0].date
          if (this.checkIfTodayDateIsAfter(date)) {
            return {
              borderColor: '#ddaf3e'
            }
          }
        }
        return {}
      },
      getLeftRoundedStyle(index) {
        let extraCount = 0
        if (this.activities[this.activitiesDates[0]].length <= 2) {
          extraCount = 1
        }
        const spliceYourRange = this.dateInGroup.slice(
          index * 2 + extraCount,
          index * 2 + 2 + extraCount
        )

        // For the last rectangle box in the loop
        if (this.isOddLoop) {
          // Check if the roundedTimeIndex is the lasted of the loop
          // Check if the last date is passed
          if (index + 1 === this.roundedTimes) {
            if (
              this.checkIfTodayDateIsAfter(this.activitiesDates[this.activitiesDates.length - 1])
            ) {
              return {
                borderColor: '#ddaf30'
              }
            }
          }
        }
        if (spliceYourRange[0]?.date && this.checkIfTodayDateIsAfter(spliceYourRange[0]?.date)) {
          return {
            borderColor: '#ddaf3e'
          }
        }
        return {}
      },
      getRightRoundedStyle(index) {
        let extraCount = 0
        if (this.activities[this.activitiesDates[0]].length <= 6) {
          extraCount = 1
        }

        const spliceYourRange = this.dateInGroup?.slice(
          index * 2 + extraCount,
          index * 2 + 2 + extraCount
        )
        if (spliceYourRange?.length === 2) {
          if (spliceYourRange[1]?.date && this.checkIfTodayDateIsAfter(spliceYourRange[1]?.date)) {
            return {
              borderColor: '#ddaf3e'
            }
          }
        } else {
          const date = spliceYourRange[0]?.date
          if (date && this.checkIfTodayDateIsAfter(date)) {
            return {
              borderColor: '#ddaf3e'
            }
          }
        }
        return {}
      },
      getLastLineStyle() {
        if (this.checkIfTodayDateIsAfter(this.activitiesDates[this.activitiesDates?.length - 1]))
          return {
            borderColor: '#ddaf3e'
          }
        return {}
      }
    }
  }
